import React from 'react';
import { Card, Col, Row, Tag , Button} from "antd";
import Proveidor from '../../../model/menudesign/Proveidor';
import { FaCloudUploadAlt } from "react-icons/fa";
import Colors from "../../../styles/Colors";

interface ElementProps {
    element: Proveidor;
}

const ProveidorList: React.FC<ElementProps> = ({ element }) => {
    return (

    <Card bordered={true}>
    <Row style={{ display: "flex", justifyContent: "space-between" }}  align="top">
        {/* Columna principal - dades generals */}
        <Col flex={2}>
            <Row gutter={18}>
                <Col span={12}><b>Nom</b>: {element.nom}</Col>
                <Col span={12}><b>Email</b>: {element.email}</Col>
            </Row>

            <br />

            <Row gutter={18}>
                <Col span={12}><b>Responsable</b>: {element.responsable}</Col>
                <Col span={12}>
                    <b>Email automàtic:</b>{" "}
                    <Tag color={element.emailing ? "green" : "magenta"}>
                        {element.emailing ? "Sí" : "No"}
                    </Tag>
                </Col>
            </Row>

            <br />

            <Row gutter={16}>
                <Col span={12}>
                    <b>Reparteix</b>:{" "}
                    <Tag color={element.reparteix == 1 ? "default" : "cyan"}>
                        {element.reparteix == 1 ? "Magatzen" : "Escoles"}
                    </Tag>
                </Col>
               
                <Col span={12}>
                    <b>Telèfon</b>: {element.telefon}
                </Col>
               
            </Row>

            <br />

            <Row gutter={18}>
                <Col span={16}><b>Recordatori</b>: {element.recordatori}</Col>
            </Row>
        </Col>

        {/* Columna Document */}
        <Col flex={1}>
            <div style={{ marginBottom: 16 }}>
                <b>Document</b>:<br />
                {element.document ? (
                    element.document
                ) : (
                    <div style={{ fontStyle: "italic", color: "#999" }}>
                        No hi ha document
                    </div>
                )}

                {!element.document && (
                    <div style={{ marginTop: 8 }}>
                        <Button
                            title={"Pujar document"}
                            style={{ backgroundColor: '#a4e2ff' }}
                        >
                            <FaCloudUploadAlt />
                        </Button>
                    </div>
                )}
            </div>
        </Col>

        {/* Columna Distribucions */}
        <Col flex={1}>
            <div>
                <b>Distribucions:</b>
                {Array.isArray(element.distribucions) && element.distribucions.length > 0 ? (
                    <div style={{ marginTop: 8 }}>
                        {element.distribucions.map((dist, index) => {
                            const diesSetmana = ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"];
                            return (
                                <Tag key={index} style={{ display: "block", marginBottom: 4 }}>
                                    {dist.tipus === 1
                                        ? `Dia del mes: ${diesSetmana[dist.valor]} cada ${dist.interv} dies`
                                        : `Dia de la setmana: ${diesSetmana[dist.valor]}`}
                                </Tag>
                            );
                        })}
                    </div>
                ) : (
                    <div style={{ marginTop: 8, fontStyle: "italic", color: "#999" }}>
                        No hi ha distribucions, afegeix-les.
                    </div>
                )}
            </div>
        </Col>
    </Row>
</Card>


    );
};

export default ProveidorList;
